const triggers = document.querySelectorAll("[data-stack-trigger]")
const cssActiveClass = "is-active"
const bodyCssActiveClass = "has-popin-active"

/**
 * Handles Popin with "Stack effect"
 * Get data from html, put it in the popin.
 */
const Stack = {
	lastFocusedElement: null,
	popin: null,
	init: () => {
		if (!triggers.length) return

		// generate HTML for popin
		Stack.createPopin()

		// Open popin if ID is in the URL
		const hash = window.location.hash.substring(1)
		if (hash) {
			Stack.open(hash)
		}

		document.addEventListener("click", function(e) {
			// buttons event
			triggers.forEach((trigger) => {
				if (trigger.contains(e.target)) {
					if (e.pointerType === "mouse") {
						Stack.lastFocusedElement = null
					} else {
						Stack.lastFocusedElement = trigger
					}
					const targetId = trigger.dataset.stackTrigger
					if (targetId) {
						e.preventDefault()
						Stack.open(targetId)
					}
				}
			})

			// background overlay click while opened || close button click
			if (e.target.classList.contains("stack-popin__overlay") || e.target.id == "stack-popin-close") {
				Stack.close()
			}
		})
	},

	/**
	 * Opens the popin and append content to it
	 * @param {string} targetId
	 */
	open: (targetId) => {
		const popin = Stack.getPopin()
		if (popin) {
			Stack.appendContent(targetId)
			popin.classList.add(cssActiveClass)
			document.body.classList.add(bodyCssActiveClass)
		}
		history.pushState(null, null, "#" + targetId)
		document.addEventListener("keydown", Stack.handleEscape)
		// set focus inside and trap it in
		popin.focus()
		document.addEventListener("focus", Stack.trapFocus, true)
	},

	close: () => {
		const popin = Stack.getPopin()
		if (popin) {
			popin.classList.remove(cssActiveClass)
			document.body.classList.remove(bodyCssActiveClass)
		}
		history.pushState(null, null, " ")
		document.removeEventListener("keydown", Stack.handleEscape)
		document.removeEventListener("focus", Stack.trapFocus, true)
		// Restore focus to the last focused element
		if (Stack.lastFocusedElement) {
			Stack.lastFocusedElement.focus()
		}
	},

	handleEscape: (e) => {
		if (e.key === "Escape") {
			Stack.close()
		}
	},

	trapFocus: (e) => {
		const popin = Stack.getPopin()
		if (!popin.contains(e.target)) {
			e.stopPropagation()
			popin.focus()
		}
	},

	getPopin: () => {
		if (!Stack.popin) {
			Stack.popin = document.getElementById("site-popin")
		}
		return Stack.popin
	},

	/**
	 * append text / content to the popin
	 * @param {string} targetId ID of the popin/stack item
	 */
	appendContent: (targetId) => {
		const dataContainer = document.getElementById("content-" + targetId)
		const title = dataContainer.dataset.stackTitle
		const content = dataContainer.innerHTML
		document.querySelector("[data-popin-content]").innerHTML = content == false ? "<p>Aucun contenu à afficher.</p>" : content
	},

	/**
	 * Generate popin base html
	 */
	createPopin: () => {
		const div = document.createElement("div")
		div.className = "stack-popin"
		div.id = "site-popin"
		div.setAttribute("tabindex", "-1")
		div.innerHTML = `<section class="stack-popin__window">
							<button id="stack-popin-close" class="stack-popin__close-button button-close"></button>
							<div class="stack-popin__scrollable">
								<div class="stack-popin__content" data-popin-content></div>
							</div>
						</section>
						<div class="stack-popin__overlay"></div>`
		document.body.appendChild(div)
	},
}

export default Stack
